import { Paper, Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Skeleton, Stack } from '@mui/material';

const ForecastSkeleton = () => {
  return (
    <Paper elevation={0} sx={{ border: "none"}}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 16px" }}>
        <Box>
          <Skeleton variant="text" width={200} height={32} />
          <Skeleton variant="text" width={400} height={24} />
        </Box>
        <Skeleton variant="rectangular" width={150} height={40} />
      </Box>
      <TableContainer sx={{ overflow: 'visible' }}>
        <Table aria-label="collapsible table" size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {Array.from({ length: 27 }).map((_, index) => (
                <TableCell key={index} sx={{ padding: "0px 8px !important" }}>
                  <Skeleton variant="text" width={80} height={20} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: 12 }).map((_, rowIndex) => (
              <TableRow key={rowIndex} sx={{ height: 35 }}>
                {Array.from({ length: 27 }).map((_, cellIndex) => (
                  <TableCell key={cellIndex} sx={{ padding: "0px 8px !important" }}>
                    <Skeleton variant="text" width={60} height={20} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center"></Stack>
      </TableContainer>
    </Paper>
  );
};

export default ForecastSkeleton;
